import React from 'react';

/**
 * wraps children with wrapper if condition is true
 */
var ConditionalWrapper = function (_a) {
    var condition = _a.condition, wrapper = _a.wrapper, _b = _a.children, children = _b === void 0 ? React.createElement(React.Fragment, null) : _b;
    return condition ? wrapper(children) : children;
};

export { ConditionalWrapper };
//# sourceMappingURL=index.js.map
